<div class="container" *ngIf="vm$ | async as vm">
  <ng-container *ngIf="!vm.isLoading">
    <!-- Mobile Header using reusable component -->
    <app-mobile-detail-header
      title="Payout Detail"
      [showDownload]="true"
      [downloadDisabled]="vm.currentDisbursementHistory?.transactionStatus !== 'SUCCESS'"
      [breadcrumb]="breadcrumbComponent"
      (back)="goBack()"
      (download)="download()"
    >
    </app-mobile-detail-header>

    <!-- Desktop/Tablet Header -->
    <div class="title-wrap desktop-header">
      <div>
        <h2 id="page-title">Payout Detail</h2>
        <app-breadcrumb #breadcrumbComponent></app-breadcrumb>
      </div>
      <div class="download-wrapper">
        <button
          [disabled]="vm.currentDisbursementHistory?.transactionStatus !== 'SUCCESS'"
          (click)="download()"
          class="download-btn"
        >
          <span class="icon download"></span> Download Receipt
        </button>
      </div>
    </div>
    <div class="payout-detail-container">
      <div class="detail-left-column">
        <!-- unified payout detail card -->
        <div class="payout-detail">
          <div class="payout-detail__header">
            <h4>Payout Detail</h4>
          </div>

          <div class="payout-detail__content">
            <div class="wrapper">
              <span class="item item--title">Created Date</span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.createdAt | date: 'dd MMM yyyy, hh:mm a' }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Last Update </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.updatedAt | date: 'dd MMM yyyy, hh:mm a' }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Type </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.bulkId ? 'Bulk' : 'Single' }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Created By </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.createdBy }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Sender </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.senderName }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Reference ID </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.referenceId || '-' }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Remarks </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.remark || '-' }}
              </span>
            </div>
            <div class="wrapper wrapper--divider">
              <span class="item item--title item--highlight"> Amount</span>
              <span class="item item--value item--highlight">
                {{
                  vm.currentDisbursementHistory?.amount
                    | currency: 'IDR' : 'symbol' : '1.2-2' : 'id'
                }}
              </span>
            </div>

            <!-- disbursement detail section -->
            <p class="section-title" style="margin-top: 24px; margin-bottom: 16px">
              Disbursement Detail
            </p>

            <div class="wrapper">
              <span class="item item--title"> Payout ID </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.uuid }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Bank Reference </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.bankReferenceNo || '-' }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Bank Name </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.beneficiaryBankName }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Account Number </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.beneficiaryAccountNo }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Beneficiary </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.beneficiaryAccountName }}
              </span>
            </div>
            <div class="wrapper" *ngIf="vm.currentDisbursementHistory?.bulkId">
              <span class="item item--title"> Batch ID </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.bulkId }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Fee </span>
              <span class="item item--value">
                {{
                  vm.currentDisbursementHistory?.fee | currency: 'IDR' : 'symbol' : '1.2-2' : 'id'
                }}
              </span>
            </div>
            <div class="wrapper wrapper--divider">
              <span class="item item--title item--highlight"> Total </span>
              <span class="item item--value item--highlight">
                {{
                  vm.currentDisbursementHistory?.totalAmount
                    | currency: 'IDR' : 'symbol' : '1.2-2' : 'id'
                }}
              </span>
            </div>

            <!-- approval detail section -->
            <p class="section-title" style="margin-top: 24px; margin-bottom: 16px">
              Approval Detail
            </p>

            <div class="wrapper">
              <span class="item item--title"> Approval Status </span>
              <span class="item item--value">
                <lib-badge
                  [label]="vm.currentDisbursementHistory?.status || '' | titlecase"
                  size="Medium"
                  variant="Outline"
                  [type]="getBadgeType(vm.currentDisbursementHistory?.status || '')"
                ></lib-badge>
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Approval Date </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.approvedAt | date: 'dd MMM yyyy, hh:mm a' }}
              </span>
            </div>
            <div class="wrapper">
              <span class="item item--title"> Approved By </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.approvedBy }}
              </span>
            </div>
            <div class="wrapper" *ngIf="vm.currentDisbursementHistory?.rejectReason">
              <span class="item item--title"> Reject Reason </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.rejectReason }}
              </span>
            </div>

            <div class="wrapper" *ngIf="vm.currentDisbursementHistory?.transactionReasonType">
              <span class="item item--title"> Reason </span>
              <span class="item item--value">
                {{
                  vm.currentDisbursementHistory?.transactionReasonType ?? ''
                    | transactionTypeReasonPipe
                }}
              </span>
            </div>
            <div class="wrapper" *ngIf="vm.currentDisbursementHistory?.failedReason">
              <span class="item item--title"> Failed Reason </span>
              <span class="item item--value">
                {{ vm.currentDisbursementHistory?.failedReason }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-right-column">
        <!-- Reusable Status Timeline Template -->
        <ng-template #statusTimelineTemplate let-steps="steps" let-showLine="showLine">
          <div
            class="status-step"
            *ngFor="let step of steps; let i = index; let isLast = last"
            [class.pending-status]="step.status === 'pending'"
          >
            <div class="status-icon-wrapper">
              <i [class]="'icon ' + getStatusIconClass(step)" class="status-icon"></i>
              <div class="status-line" *ngIf="showLine && !isLast"></div>
            </div>

            <div class="status-content" [class.future-status]="!step?.timestamp">
              <h3 class="status-title">{{ step.label }}</h3>
              <p class="status-description">{{ step.description }}</p>

              <div
                *ngIf="step.recommendation && step.recommendation.trim() !== ''"
                class="processing-notice"
              >
                <div class="notice-content">
                  <span class="notice-icon">💡</span>
                  <span>{{ step.recommendation }}</span>
                </div>

                <div class="recommendation-actions">
                  <span
                    *ngIf="shouldShowTopUpCTA(step.recommendation)"
                    (click)="showTopUpDialog()"
                    class="cta-link"
                  >
                    Top Up Balance
                  </span>

                  <span
                    *ngIf="shouldShowContactHelpdesk(step.recommendation)"
                    (click)="contactHelpdesk()"
                    class="cta-link"
                  >
                    Contact Helpdesk
                  </span>
                </div>
              </div>

              <span class="status-date" *ngIf="step.date">
                {{ step.date | date: 'dd MMM yyyy, HH:mm:ss' }}
              </span>
            </div>
          </div>
        </ng-template>

        <!-- Mobile: Show status at top of card with expandable timeline -->
        <div class="mobile-status-card">
          <div class="mobile-status-header">
            <h4>Payout Status</h4>
            <lib-badge
              [label]="getOverallStatusLabel(vm.currentDisbursementHistory || null)"
              size="Medium"
              variant="Outline"
              [type]="getOverallStatusBadgeType(vm.currentDisbursementHistory || null)"
            >
            </lib-badge>
          </div>

          <!-- Mobile Status Timeline -->
          <div class="mobile-status-timeline" *ngIf="statusHistory.length > 0">
            <ng-container
              *ngTemplateOutlet="
                statusTimelineTemplate;
                context: {
                  steps: visibleStatusHistory(),
                  showLine: showAllStatuses() && statusHistory.length > 1,
                }
              "
            ></ng-container>

            <!-- View More / View Less Button -->
            <button
              class="view-more-btn"
              *ngIf="statusHistory.length > 1"
              (click)="toggleStatusView()"
            >
              <span>{{ showAllStatuses() ? 'View Less' : 'View More' }}</span>
              <i
                class="pi"
                [class.pi-chevron-up]="showAllStatuses()"
                [class.pi-chevron-down]="!showAllStatuses()"
              ></i>
            </button>
          </div>

          <!-- Fallback if no status data -->
          <div *ngIf="statusHistory.length === 0" class="no-status-message-mobile">
            <p>No status history available</p>
          </div>
        </div>

        <!-- Desktop/Tablet: Original layout -->
        <div class="payout-detail desktop-status-card">
          <div class="payout-detail__header" style="text-align: left">
            <h4>Payout Status</h4>
            <div class="status-badge-wrapper">
              <lib-badge
                [label]="getOverallStatusLabel(vm.currentDisbursementHistory || null)"
                size="Medium"
                variant="Outline"
                [type]="getOverallStatusBadgeType(vm.currentDisbursementHistory || null)"
              >
              </lib-badge>
            </div>
          </div>
          <div style="padding: 20px 20px 20px 0px; border: none">
            <div class="status-timeline" *ngIf="statusHistory.length > 0">
              <ng-container
                *ngTemplateOutlet="
                  statusTimelineTemplate;
                  context: {
                    steps: statusHistory,
                    showLine: true,
                  }
                "
              ></ng-container>
            </div>

            <!-- Fallback if no data -->
            <div *ngIf="statusHistory.length === 0" class="no-status-message">
              <p>No status history available for this transaction.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <app-block-loading [show]="vm.isLoading"></app-block-loading>
</div>
